const UnauthorizedPage = () => {
  return (
    <div className="min-h-screen bg-[#f8f8f8] flex items-center justify-center px-4">
      <div className="bg-white w-full max-w-md rounded-3xl shadow-xl p-10 text-center border border-gray-100">
        <div className="w-20 h-20 mx-auto rounded-full bg-red-100 flex items-center justify-center mb-6">
          <span className="text-4xl">🚫</span>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-3">
          Unauthorized Access
        </h1>

        <p className="text-gray-600 text-base leading-7 mb-8">
          You do not have permission to access this page. Please contact your
          administrator or return to the home page.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => window.history.back()}
            className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-100 transition"
          >
            Go Back
          </button>

          <button
            onClick={() => (window.location.href = "/")}
            className="px-6 py-3 rounded-xl bg-[#F5A623] text-white font-semibold hover:opacity-90 transition"
          >
            Home Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
